module.exports = __webpack_public_path__ + "img/mubang-2.823012cf.png";